import { Utils } from "./Utils";
class UtilsDictionary {
    items = {};
    constructor(key, value) {
        if (key != null) {
            this.set(key, value);
        }
    }
    /**
     * 检查是否有某一个键
     * @param key 键
     */
    has(key) {
        return Reflect.has(this.items, key);
    }
    /**
     * 检查已有的键中是否以xx开头
     * @param key 需要匹配的键
     */
    startsWith(key) {
        let allKeys = this.keys();
        for (const keyName of allKeys) {
            if (String(keyName).startsWith(String(key))) {
                return true;
            }
        }
        return false;
    }
    /**
     * 获取以xx开头的键的值
     * @param key 需要匹配的键
     */
    getStartsWith(key) {
        let allKeys = this.keys();
        let result = void 0;
        for (const keyName of allKeys) {
            if (String(keyName).startsWith(String(key))) {
                result = this.get(keyName);
                break;
            }
        }
        return result;
    }
    /**
     * 为字典添加某一个值
     * @param key 键
     * @param val 值，默认为""
     */
    set(key, val) {
        if (key === void 0) {
            throw new Error("Utils.Dictionary().set 参数 key 不能为空");
        }
        Reflect.set(this.items, key, val);
    }
    /**
     * 删除某一个键
     * @param key 键
     */
    delete(key) {
        if (this.has(key)) {
            return Reflect.deleteProperty(this.items, key);
        }
        return false;
    }
    /**
     * 获取某个键的值
     * https://github.com/microsoft/TypeScript/issues/9619
     * 微软到现在都没有修复has和get的联动
     * @param key 键
     */
    get(key) {
        return Reflect.get(this.items, key);
    }
    /**
     * 返回字典中的所有值
     */
    values() {
        let resultList = [];
        for (let prop in this.getItems()) {
            if (this.has(prop)) {
                resultList.push(this.get(prop));
            }
        }
        return resultList;
    }
    /**
     * 清空字典
     */
    clear() {
        this.items = null;
        this.items = {};
    }
    /**
     * 获取字典的长度
     */
    size() {
        return Object.keys(this.getItems()).length;
    }
    /**
     * 获取字典所有的键
     */
    keys() {
        return Reflect.ownKeys(this.items);
    }
    /**
     * 返回字典本身
     */
    getItems() {
        // @ts-ignore
        return this.items;
    }
    /**
     * 合并另一个字典
     * @param data 需要合并的字典
     */
    concat(data) {
        this.items = Utils.assign(this.items, data.getItems());
    }
    forEach(callbackfn) {
        for (const key in this.getItems()) {
            callbackfn(this.get(key), key, this.getItems());
        }
    }
    /**
     * 获取字典的长度，同this.size
     */
    get length() {
        return this.size();
    }
    /**
     * 迭代器
     */
    get entries() {
        let that = this;
        return function* () {
            let itemKeys = Object.keys(that.getItems());
            for (const keyName of itemKeys) {
                yield [keyName, that.get(keyName)];
            }
        };
    }
    /**
     * 是否可遍历
     */
    get [Symbol.iterator]() {
        let that = this;
        return function () {
            return that.entries();
        };
    }
}
export { UtilsDictionary };
